module.exports = __webpack_public_path__ + "static/img/fifth4.f90a8e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/fifth4.png
// module id = Ib29
// module chunks = 25